import useAlias from '@alias';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  Grid2 as Grid,
  Stack,
  Switch,
  Tooltip,
  useTheme,
} from '@mui/material';
import { getTemplatesViewSx } from '@src/components/_shared/sxStyles/Config/templates';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import { ControlAuthorities } from '@src/types/ControlModes';
import { CombinedControlModeField } from '@src/types/Stacks';
import TemplatesFields from '../TemplatesFields';

interface TemplateCardConfigProps {
  quickConfigFields: CombinedControlModeField[];
  activeStatus: number | undefined;
  controlAuthority: ControlAuthorities | undefined | null;
  onSubmit: () => void;
  handleToggleUpdate: () => void;
  handleOpen: () => void;
}

export const TemplateCardConfig = ({
  quickConfigFields,
  activeStatus,
  controlAuthority,
  onSubmit,
  handleToggleUpdate,
  handleOpen,
}: TemplateCardConfigProps) => {
  const theme = useTheme();
  const templatesViewSx = getTemplatesViewSx(theme);
  const alias = useAlias();

  return (
    <Grid size={8}>
      <Stack direction={'row'} sx={templatesViewSx.configWrapper} spacing={2}>
        <Box display={'flex'} alignItems='center'>
          <Box>
            <Tooltip
              title={alias('Must be in HMI mode in order to enable/disable.')}
              arrow
              placement='top'
              disableHoverListener={
                controlAuthority !== ControlAuthorities.scada
              }
            >
              <Box>
                <Switch
                  checked={activeStatus === 0}
                  onChange={handleToggleUpdate}
                  disabled={
                    controlAuthority === ControlAuthorities.scada ||
                    controlAuthority === ControlAuthorities.calendar
                  }
                />
              </Box>
            </Tooltip>
          </Box>
        </Box>
        <Stack spacing={3} flexGrow={1}>
          <TemplatesFields inputFields={quickConfigFields} />
          <Stack
            direction='row'
            spacing={2}
            sx={templatesViewSx.configWrapper.buttonWrapper}
          >
            {quickConfigFields.length > 0 && (
              <Button
                variant='contained'
                color='primary'
                size='small'
                type='submit'
                onClick={onSubmit}
              >
                <FormattedAlias id='Quick Save' />
              </Button>
            )}
            <Button
              variant='outlined'
              color='inherit'
              size='small'
              startIcon={<EditIcon />}
              onClick={handleOpen}
            >
              <FormattedAlias id='Full Config' />
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Grid>
  );
};
